import { defaultCardRenderer, TableColumn } from '@amzn/stencil-react-components/table';

export function createCardRenderer(columns: TableColumn[]) {
  return defaultCardRenderer({
    columns,
    useCellComponents: true,
  });
}
